/* Elise Hatsuko theme — small, dependency-free */
(function () {
  'use strict';

  /* Mobile menu drawer */
  var drawer = document.getElementById('MenuDrawer');
  var toggles = document.querySelectorAll('[data-menu-open]');
  var closers = document.querySelectorAll('[data-menu-close]');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = drawer.querySelector('a,button'); if (f) f.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  toggles.forEach(function (b) { b.addEventListener('click', openDrawer); });
  closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Product form: variant selection via radio options */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variants = JSON.parse(productForm.getAttribute('data-variants') || '[]');
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = productForm.querySelector('[data-add]');
    var moneyFormat = productForm.getAttribute('data-money-format') || '${{amount}}';

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      if (v.endsWith('.00')) v = v.slice(0, -3);
      v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function selected() {
      var vals = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        vals.push(checked ? checked.value : null);
      });
      return vals;
    }
    function update() {
      var vals = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) { compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-label-add') : (addBtn.getAttribute('data-label-sold-out') || 'Sold out');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }
    productForm.querySelectorAll('[data-option-index] input').forEach(function (i) { i.addEventListener('change', update); });
    update();

    /* quantity */
    productForm.querySelectorAll('[data-qty-change]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = productForm.querySelector('[name="quantity"]');
        var n = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty-change'), 10);
        input.value = Math.max(1, n);
      });
    });
  }

  /* Cart: quantity changes submit the form */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.form && input.form.submit(); });
  });
})();

